// package: friendemic.api.response
// file: friendemic/api/response/review_response_ticket.proto
"use strict";

exports.StatusFriendly = {
  enumMap: {
		0: "Unknown",
		5: "Review Updated",
		6: "Network Accepted",
		7: "Response Submitted",
		8: "Unavailable",
		9: "ERC Completed",
		10: "Externally Completed",
		11: "Sent To Network",
		12: "Edits Requested",
		13: "New",
  },
  friendlyMap: {
		"Unknown": 0,
		"Review Updated": 5,
		"Network Accepted": 6,
		"Response Submitted": 7,
		"Unavailable": 8,
		"ERC Completed": 9,
		"Externally Completed": 10,
		"Sent To Network": 11,
		"Edits Requested": 12,
		"New": 13,
  },
  toFriendly: function(e) {
    const v = this.enumMap[e]
    if (v === undefined) {
      throw new Error(e + ' is not a valid ReviewResponseTicketFilters.Status enum option')
    }

    return v
  },
  toEnum: function(v) {
    const e = this.friendlyMap[v]
    if (e === undefined) {
      throw new Error('\'' + v + '\'' + ' is not a valid ReviewResponseTicketFilters.Status friendly value')
    }

    return e
  }
}
